<template>
  <el-dialog title="全部跟进人信息" :visible.sync="dialogVisible" width="560px" :before-close="handleClose">
    <el-table :data="list" header-row-class-name="table-header-row" row-class-name="table-row">
      <el-table-column prop="partner_role_name" label="跟进人"></el-table-column>
      <el-table-column prop="follow_time" label="最近跟进时间"></el-table-column>
      <el-table-column prop="cooperate_status_name" label="合作状态"></el-table-column>
    </el-table>
    <span slot="footer">
      <el-button type="primary" @click="handleClose">我知道了</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'followDialog',
  data () {
    return {
      list: [],
      dialogVisible: false
    }
  },
  methods: {
    show(list = []) {
      this.list = list
      this.dialogVisible = true
    },
    handleClose() {
      this.list = []
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .el-table__body-wrapper {
  max-height: 580px;
  overflow-y: auto;
}
</style>
